module.exports = __webpack_public_path__ + "img/bankcode1.88f9c78b.png";